/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from '../../../../../../core/services';

@Injectable()
export class WizardNavigationService {
    /**
     * To store the wizard title.
     */
    public wizardTitle: string = '';

    /**
     * Store the title for the cancel wizard button.
     */
    public cancelText: string;

    /**
     * Redirect url based on user's current page.
     */
    public parentURL: string;

    /**
     * Store the available wizard templates.
     */
    public availableTemplates: any = [];

    /**
     * To store the wizard options.
     */
    public options: any = {};

    /**
     * A boolean to determine if the wizard is in edit mode or not.
     */
    public editMode: boolean = false;

    /**
     * A boolean to determine if the wizard data is a duplicate or not.
     */
    public duplicate: boolean = false;

    /**
     * The callback function to be called on submit.
     */
    public submitCallback: (...args: any[]) => void;

    constructor(
        private navigationService: NavigationService,
        private router: Router,
    ) {
    }

    /**
     * Set the wizard data in to the class variables.
     * @param data
     */
    public setWizardData(data) {
        const {
            wizardTitle,
            cancelText,
            parentUrl,
            availableTemplates,
            submitCallback,
            editMode,
            duplicate,
            options
        } = data;
        this.wizardTitle = wizardTitle;
        this.cancelText = cancelText;
        this.parentURL = parentUrl;
        this.availableTemplates = availableTemplates;
        this.submitCallback = submitCallback;
        this.editMode = editMode;
        this.duplicate = duplicate;
        this.options = options;
    }

    /**
     * Get the wizard options.
     */
    public getWizardData(): any {
        return {
            wizardTitle: this.wizardTitle,
            cancelText: this.cancelText,
            parentUrl: this.parentURL,
            availableTemplates: this.availableTemplates,
            submitCallback: this.submitCallback,
            options: this.options
        };
    }

    /**
     * Navigate to supplied URL.
     * @param url
     */
    public navigateToUrl(url) {
        this.router.navigateByUrl(this.navigationService.getEnduranceUrl(url)).then().catch();
    }
}
